module.exports = "/static/assets/d85331a416a9a79b829ced3d0e104e88.png";